module.exports = __webpack_public_path__ + "static/media/missing_availability_info.6b7d9fca.svg";